import {
  listeCarteImageNomMock,
  pushArticlesBlogB2cMock,
  texteSeoMock,
  titreDescriptionMock,
  titreTexteCtaImageMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreDescriptionMock(true, false),
  listeCarteImageNomMock('meuble'),
  titreTexteCtaImageMock(),
  pushArticlesBlogB2cMock,
  texteSeoMock(),
];

export const meublesMock: SlugPage = {
  ...pageBase({
    title: 'Meubles',
    type: 'meubles',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
